/* A YouTube video is a cover of our own until it is asked for. The player is
   ~700 KB across three Google domains, and loading it when the block scrolls
   into view spends that on everyone who reads that far, not on the few who
   press play. The click that asks for the video is the one that fetches it,
   and autoplay keeps it a single click.

   Markup: a <button class="video-facade" data-video-id="..."> holding the
   cover image, inside a .iframe-wrap that already has the player's box. Used
   by the home page's reviews block and the detector's review video.

   This used to live in data_q.js, which the detector page does not load. */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.video-facade').forEach(function (facade) {
        facade.addEventListener('click', function () {
            const frame = document.createElement('iframe');
            frame.src = 'https://www.youtube.com/embed/' + facade.dataset.videoId + '?autoplay=1';
            frame.title = facade.getAttribute('aria-label') || 'YouTube video player';
            frame.width = 560;
            frame.height = 315;
            frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            frame.referrerPolicy = 'strict-origin-when-cross-origin';
            frame.allowFullscreen = true;
            facade.replaceWith(frame);
        }, { once: true });
    });
});
